import PropTypes from 'prop-types'
import { USBGrid, USBColumn } from '@usb-shield/react-grid/dist/esm/'
import styles from './digital.module.scss'

const DigitalService = ({ digitalContent }) => {
  const openingSection = digitalContent?.openingSection
  const sectionOneBody = digitalContent?.sectionOneBody
  const sectionTwoBody = digitalContent?.sectionTwoBody
  const sectionThreeBody = digitalContent?.sectionThreeBody
  const sectionFourBody = digitalContent?.sectionFourBody
  const sectionFiveBody = digitalContent?.sectionFiveBody
  const sectionSixBodyPartOne = digitalContent?.sectionSixBodyPartOne
  const sectionSixBodyPartTwo = digitalContent?.sectionSixBodyPartTwo
  const sectionSixBodyPartThree = digitalContent?.sectionSixBodyPartThree
  const sectionSixBodyPartFour = digitalContent?.sectionSixBodyPartFour
  const sectionSixBodyPartFive = digitalContent?.sectionSixBodyPartFive
  const sectionSevenBody = digitalContent?.sectionSevenBody
  const sectionEightBodyPartOne = digitalContent?.sectionEightBodyPartOne
  const sectionEightBodyPartTwo = digitalContent?.sectionEightBodyPartTwo
  const sectionNineBody = digitalContent?.sectionNineBody
  const sectionTenBody = digitalContent?.sectionTenBody
  const contactUsBody = digitalContent?.contactUsBody
  const contactUnauthorizedTransactionsContent =
    digitalContent?.contactUnauthorizedTransactionsContent

  return (
    <>
      <div className={styles['terms-conditions']} role="main">
        <USBGrid>
          <USBColumn mediumSpan={16} largeSpan={16}>
            <div className={styles['terms-conditions--disclosures']}>
              <p className={styles['terms-conditions--para']}>
                <div className={styles['terms-conditions--content']}>
                  <h1>{digitalContent?.mainHeading}</h1>
                  <h2>{digitalContent?.openingHeader}</h2>
                  <div dangerouslySetInnerHTML={{ __html: openingSection }} />
                  <h2>{digitalContent?.sectionOneHeader}</h2>
                  <div dangerouslySetInnerHTML={{ __html: sectionOneBody }} />
                  <h1>{digitalContent?.sectionTwoHeader}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionTwoBody }} />
                  <h1>{digitalContent?.sectionThreeHeader}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionThreeBody }} />
                  <h1>{digitalContent?.sectionFourTitle}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionFourBody }} />
                  <h1>{digitalContent?.sectionFiveTitle}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionFiveBody }} />
                  <h1>{digitalContent?.sectionSixTitle}</h1>
                  <div
                    dangerouslySetInnerHTML={{ __html: sectionSixBodyPartOne }}
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: sectionSixBodyPartTwo }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sectionSixBodyPartThree
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: sectionSixBodyPartFour }}
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: sectionSixBodyPartFive }}
                  />
                  <h1>{digitalContent?.sectionSevenTitle}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionSevenBody }} />
                  <h1>{digitalContent?.sectionTenTitle}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionTenBody }} />
                  <h1>{digitalContent?.sectionEightTitle}</h1>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sectionEightBodyPartOne
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sectionEightBodyPartTwo
                    }}
                  />
                  <h1>{digitalContent?.sectionNineTitle}</h1>
                  <div dangerouslySetInnerHTML={{ __html: sectionNineBody }} />
                  <h1>{digitalContent?.contactUsHeader}</h1>
                  <div dangerouslySetInnerHTML={{ __html: contactUsBody }} />
                  <br />
                  <h3>{digitalContent?.contactUsOneLabel}</h3>
                  <p>{digitalContent?.contactUsOneNumber}</p>
                  <br />
                  <h3>{digitalContent?.contactUsTwoLabel}</h3>
                  <p>{digitalContent?.contactUsTwoNumber}</p>
                  <br />
                  <h3>{digitalContent?.contactUsThreeLabel}</h3>
                  <p>{digitalContent?.contactUsThreeNumber}</p>
                  <p>{digitalContent?.contactUsTimeFrameDaysOne}</p>
                  <p>{digitalContent?.contactUsTimeFrameHoursOne}</p>
                  <br />
                  <h3>{digitalContent?.contactUsFourLabel}</h3>
                  <p>{digitalContent?.contactUsFourNumber}</p>
                  <br />
                  <h3>{digitalContent?.contactUsFiveLabel}</h3>
                  <p>{digitalContent?.contactUsFiveNumber}</p>
                  <br />
                  <h3>{digitalContent?.contactUsSixLabel}</h3>
                  <p>{digitalContent?.contactUsTimeFrameDaystwo}</p>
                  <p>{digitalContent?.contactUsTimeFrameHoursTwo}</p>
                  <p>{digitalContent?.contactUsTimeFrameDaysThree}</p>
                  <p>{digitalContent?.contactUsTimeFrameHoursThree}</p>
                  <br />
                  <h3>{digitalContent?.contactUsSevenLabel}</h3>
                  <p>{digitalContent?.contactUsSevenNumber}</p>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: contactUnauthorizedTransactionsContent
                    }}
                  />
                  <br />
                  <br />
                </div>
              </p>
            </div>
          </USBColumn>
        </USBGrid>
      </div>
    </>
  )
}

DigitalService.propTypes = {
  digitalContent: PropTypes.objectOf(PropTypes.any).isRequired
}

export default DigitalService
